import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-md-6 offset-md-3" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "user-role" }, "Role :", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select a role", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "user-parents-name" }, "BusinessUnit Parent Name :", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select parent unit", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row mb-3" }
const _hoisted_15 = { class: "col-md-6 offset-md-3" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "user-role" }, "Role :", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select a role", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "user-parents-name" }, "BusinessUnit Parent Name :", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select parent unit", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_ctx.isAssigned === false)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_modal, {
          title: "Assign",
          onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.CreateRole())),
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelAssign()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-lg",
                      id: "user-role",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRole) = $event))
                    }, [
                      _hoisted_6,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: role.id,
                          value: role.id
                        }, _toDisplayString(role.name), 9, _hoisted_7))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedRole]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-lg",
                      id: "user-parents-name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newBusinessName) = $event))
                    }, [
                      _hoisted_10,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (businessUnit) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: businessUnit.id,
                          value: businessUnit.id
                        }, _toDisplayString(businessUnit.name), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newBusinessName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn btn-primary mx-2",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.CreateRole && _ctx.CreateRole(...args)))
                    }, "Assign"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary mx-2",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelAssign()))
                    }, "Cancel")
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createVNode(_component_modal, {
          title: "Assign",
          onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.UpdateRole())),
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelAssign()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-lg",
                      id: "user-role",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRole) = $event))
                    }, [
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: role.id,
                          value: role.id
                        }, _toDisplayString(role.name), 9, _hoisted_19))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedRole]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control form-control-lg",
                      id: "user-parents-name",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newBusinessName) = $event))
                    }, [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (businessUnit) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: businessUnit.id,
                          value: businessUnit.id
                        }, _toDisplayString(businessUnit.name), 9, _hoisted_23))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.newBusinessName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "btn btn-primary mx-2",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.UpdateRole && _ctx.UpdateRole(...args)))
                    }, "Update"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary mx-2",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelAssign()))
                    }, "Cancel")
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]))
}